import { useState } from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Body2 } from '@/components/ui/typography'
import { FileUp, ShieldCheck } from 'lucide-react'
import { links } from 'utils/featureToggles'

import { BulkRestrictionsUploadModal } from './BulkRestrictionsUploadModal'

export const BulkRestrictionsPage = () => {
  const [isUploadModalOpen, setUploadModalOpen] = useState(false)

  return (
    <>
      <Breadcrumbs
        crumbs={[{ title: 'Bulk Restrictions', link: links.brokerageBulkRestrictions.url }]}
      />

      <Card className='mt-6 w-full max-w-3xl'>
        <CardContent className='flex flex-col gap-6 md:flex-row md:items-center md:justify-between'>
          <div className='flex items-start gap-4'>
            <div className='flex size-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary'>
              <ShieldCheck className='size-5' />
            </div>

            <Body2 className='max-w-xl text-muted-foreground'>
              Use the upload function to apply restrictions to the associated wallets of imported
              Trading Accounts.
            </Body2>
          </div>

          <Button size='lg' className='w-fit shrink-0' onClick={() => setUploadModalOpen(true)}>
            <FileUp />
            Upload Trading Accounts
          </Button>
        </CardContent>
      </Card>

      {isUploadModalOpen && (
        <BulkRestrictionsUploadModal onClose={() => setUploadModalOpen(false)} />
      )}
    </>
  )
}
